import React from 'react';
import { FaPhone, FaMapLocationDot, FaClock } from 'react-icons/fa6';
import Logo from '../assets/images/LOGO_BBYSHIN_2.webp';


export default function Maps() {
    return (
        <section id='location' className='flex flex-col h-full min-h-screen w-full gap-12 justify-center items-center py-16 bg-gradient-to-b from-[#ffe600e7] to-black'>
            <header className='w-full flex flex-col items-center gap-4'>
                <h2 className="text-5xl md:text-7xl font-['PoppinsB'] text-center">LOKASI</h2>
                <div className="w-24 h-1 bg-[#fcfc00c0]"></div>
                <p className="text-gray-600 text-center max-w-2xl px-4">Temukan Layanan Towing BBYSHIN di lokasi strategis untuk melayani kebutuhan anda</p>
            </header>

            <div className='w-full max-w-7xl flex flex-col lg:flex-row-reverse gap-8 px-8'>
                <div className='w-full lg:w-1/2 h-[400px]'>
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3955.321291494222!2d112.16402137500242!3d-7.539895592473457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zN8KwMzInMjMuNiJTIDExMsKwMDknNTkuOCJF!5e0!3m2!1sid!2sid!4v1725323937291!5m2!1sid!2sid" 
                        allowFullScreen 
                        loading="lazy" 
                        className='rounded-2xl shadow-lg w-full h-full border border-gray-100' 
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>

                <div className='w-full lg:w-1/2'>
                    <div className='w-full h-full p-8 bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transform hover:-translate-y-1 duration-300'>
                        <h3 className="text-2xl md:text-3xl font-['PoppinsB'] font-bold text-black text-center mb-8">
                            JASA DEREK TOWING BBYSHIN
                        </h3>
                        <div className='flex flex-col gap-6'>
                            <div className="flex items-center gap-6 group">
                                <div className='w-12 h-12 rounded-full bg-[#fcfc00c0] flex items-center justify-center'>
                                    <FaMapLocationDot className='w-5 h-5' />
                                </div>
                                <p className="w-96 text-gray-600 font-semibold text-lg md:block hidden">
                                    Office Perum KD.Asri No.A 18 Tegalsari, Kayen, Kec. Bandarkedungmulyo, Kabupaten Jombang, Jawa Timur 61462
                                </p>
                                <p className="w-48 text-gray-600 font-semibold text-lg md:hidden block">
                                    Kabupaten Jombang, Jawa Timur
                                </p>
                            </div>
                            <div className="flex items-center gap-6 group">
                                <div className='w-12 h-12 rounded-full bg-[#fcfc00c0] flex items-center justify-center'>
                                    <FaPhone className='w-5 h-5' />
                                </div>
                                <p className="text-gray-600 font-semibold text-lg">+6282288349889</p>
                            </div>
                            <div className="flex items-center gap-6 group">
                                <div className='w-12 h-12 rounded-full bg-[#fcfc00c0] flex items-center justify-center'>
                                    <FaClock className='w-5 h-5' />
                                </div>
                                <p className="text-gray-600 font-semibold text-lg">Selalu Buka 24 Jam</p>
                            </div>
                        </div>
                        <div className='w-full flex justify-center items-center mt-8'>
                            <img src={Logo} alt="BBYSHIN Logo" className='w-32 md:w-40 h-auto' />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
